import React from 'react';
import RegisterForm from './components/Form';
import { FormContainer } from './style.css';

const Register = () => {

    return (
        <FormContainer>
            <RegisterForm />
        </FormContainer>
    )
}

export default Register